import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { hasDuplicateElementName } from './util';
import type { IMethod } from '../../../stores/model/metamodel/method';

/**
 * Check if the owner object of the method under test has another method with
 * the same name (that is not for the same event type).
 */
class MethodDuplicateCheck extends Check<IMethod> {
  static description = 'Check for duplicate methods';

  check(): Report {
    this.report = new Report();

    if (this.element.ownerObjectType == null) {
      // This can happen when a check for this method was added while converting from specialised
      // to normal method in the process of deleting the owner object
      return this.report;
    }

    const list = this.model.methods.filter(
      (m) =>
        m.ownerObjectType === this.element.ownerObjectType &&
        m.ownerEventType !== this.element.ownerEventType
    );
    if (hasDuplicateElementName(list, this.element)) {
      this.report.addMessage(
        MessageType.ERROR,
        `Method with the same name found on the owner object (${this.element.ownerObjectType.name}).`,
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        `No methods with the same name found on the owner object (${this.element.ownerObjectType.name}).`,
        this,
        this.element
      );
    }
    return this.report;
  }
}

export default MethodDuplicateCheck;
